<template>
  <div class="pre-registration">
    <div>
      <div class="header" style="text-align: center;">
        <img v-if="logoSrc" :src="logoSrc" alt="Logo" class="logo" />
        <div v-else class="logo-placeholder"></div>
      </div>

      <el-form ref="formRef" :model="form" label-width="100px" class="form" :disabled="isDisabled">
        <h5 style="text-align: center;">{{ title }}</h5>
        <el-form-item label="姓名">
          <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证件号码">
          <el-input v-model="form.idNumber" placeholder="请输入身份证号码"></el-input>
        </el-form-item>
        <el-form-item label="预报名号">
          <el-input v-model="form.registrationNumber" placeholder="请输入预报名号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm" :disabled="isDisabled">查询</el-button>
        </el-form-item>
        <div v-if="hint" class="hint">提示：{{ hint }}</div>
      </el-form>

      <div class="copyright">
        <p>developed by 吴起航 || copyright 吴起航</p>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { ElForm, ElFormItem, ElInput, ElButton, ElMessage, ElMessageBox, ElLoading } from 'element-plus';
import axios from 'axios';

export default {
  name: 'PreRegistration',
  components: {
    ElForm,
    ElFormItem,
    ElInput,
    ElButton,
  },
  setup() {
    const logoSrc = ref('');
    const title = ref('');
    const form = ref({
      name: '',
      idNumber: '',
      registrationNumber: '',
    });
    const hint = ref('');
    const isDisabled = ref(false);
    const router = useRouter();

    const updateFavicon = (logoUrl) => {
      const faviconLink = document.querySelector('link[rel="icon"]') || document.createElement('link');
      faviconLink.rel = 'icon';
      faviconLink.href = logoUrl;
      document.head.appendChild(faviconLink);
    };

    const fetchLogo = async () => {
      try {
        const response = await axios.get('/api/logo', { responseType: 'blob' });
        const logoUrl = URL.createObjectURL(response.data);
        logoSrc.value = logoUrl;
        updateFavicon(logoUrl);
      } catch (error) {
        console.error('Error fetching logo:', error);
      }
    };

    const fetchTitle = async () => {
      try {
        const response = await axios.get('/api/title');
        title.value = response.data.title;
        document.title = response.data.title;
      } catch (error) {
        console.error('Error fetching title:', error);
        ElMessage.error('无法获取标题信息，请稍后重试');
      }
    };

    const fetchHint = async () => {
      try {
        const response = await axios.get('/api/hint');
        hint.value = response.data.hint;
      } catch (error) {
        console.error('Error fetching hint:', error);
        ElMessage.error('无法获取提示信息');
      }
    };

    const checkDisabledState = () => {
      const disabledUntil = localStorage.getItem('disabledUntil');
      const now = new Date().getTime();
      if (disabledUntil && now < Number(disabledUntil)) {
        isDisabled.value = true;
        const timeout = Number(disabledUntil) - now;
        setTimeout(() => {
          isDisabled.value = false;
          localStorage.removeItem('disabledUntil');
        }, timeout);
      }
    };

    const submitForm = async () => {
      if (isDisabled.value) {
        ElMessage.error('操作过于频繁，请稍后再试');
        return;
      }

      if (!form.value.name || !form.value.idNumber || !form.value.registrationNumber) {
        ElMessage.error('请填写所有信息');
        return;
      }

      try {
        const response = await axios.post('/find', form.value);
        if (response.data.code === 1) {
          localStorage.setItem('admittedStudentName', form.value.name);
          localStorage.setItem('admittedStudentId', form.value.idNumber);
          localStorage.setItem('admittedStudentPreregno', form.value.registrationNumber);
          localStorage.removeItem('errorCount');
          router.push('/success');
        } else if (response.data.code === 2) {
          ElMessageBox.alert(
            `查询尚未开放，请在 ${response.data.queryTime} 之后再进行查询`,
            '查询未开放',
            {
              confirmButtonText: '确定',
              type: 'warning',
            }
          );
        } else {
          handleError();
        }
      } catch (error) {
        console.error('Error submitting form:', error);
        ElMessage.error('提交失败，请稍后重试');
      }
    };

    const handleError = () => {
      let errorCount = parseInt(localStorage.getItem('errorCount') || '0', 10);
      errorCount += 1;

      if (errorCount >= 20) {
        const disabledUntil = new Date().getTime() + 5 * 60 * 1000;
        localStorage.setItem('disabledUntil', disabledUntil.toString());
        localStorage.setItem('errorCount', '0');
        isDisabled.value = true;
        setTimeout(() => {
          isDisabled.value = false;
        }, 5 * 60 * 1000);
        ElMessage.error('您已多次提交错误信息，请5分钟后再试');
      } else {
        localStorage.setItem('errorCount', errorCount.toString());
        ElMessageBox.alert('未查询到录取信息，请检查输入的信息是否正确', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
        });
      }
    };

    onMounted(async () => {
      const loadingInstance = ElLoading.service({
        fullscreen: true,
        text: '当前访问人数较多，加载中',
      });

      await Promise.all([
        fetchLogo(),
        fetchTitle(),
        fetchHint(),
      ]);

      loadingInstance.close();
      checkDisabledState();
    });

    return {
      logoSrc,
      title,
      form,
      submitForm,
      hint,
      isDisabled,
    };
  },
};
</script>

<style scoped>
.pre-registration {
  padding: 20px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.header {
  display: grid;
  place-items: center;
  width: 100%;
  height: auto;
  margin-bottom: 5px;
}

.logo {
  width: 72px;
  height: auto;
  display: block;
}

.logo-placeholder {
  width: 72px;
  height: 72px;
  margin-bottom: 20px;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.form {
  margin-top: 5px;
  flex: 1;
}

.hint {
  color: red;
  margin-top: 10px;
}

.copyright {
  text-align: center;
  margin-top: 30px;
  padding: 15px;
  font-size: 12px;
  color: #666;
}
</style>
